module.exports = {
  Matching: {
    PluginName: "Eşleştirme",
    content_box_name: "İçerik ",
    Statement: "Bu bir eşleştirme sorusudur. Sorunuzu buraya yazınız.",
    Question: "Soru",
    Feedback: "Geri Bildirim",
    FeedbackMsg:
      "Burada cevap hakkında bazı geri bildirimler sağlayabilirsiniz. Bu özelliği devre dışı bırakmak için araç çubuğunda kapatın.",
    TrueFeedbackMsg:
      "Doğru cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    FalseFeedbackMsg:
      "Yanlış cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    Answer: "Cevap",
    ShowFeedback: "Geri bildirim mesajını göster.",
    Number: "Cevap Sayısı",
    ShowLettersInsteadOfNumbers: "Sayılar yerine harfleri göster",
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Saydamlık",
    padding: "Alan",
    pos: "Pozisyon",
    radius: "Radyan",
    source: "Kaynak",
    Answer: "Cevap",
    Number: "Numara",
    tryAgain: "Tekrar Dene",
    checkAnswer: "Kontrol Et",
  },
};
